module.exports = __webpack_public_path__ + "img/location-off.2482cd2d.svg";